// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"EmbedSharing_iconContainer__b0zCW","tooltipContainer":"EmbedSharing_tooltipContainer__3vkvN","mobileIconContainer":"EmbedSharing_mobileIconContainer__NcJQx"};